import React from 'react';
import { Box, ListRow, SkeletonLoader } from '@saviynt/design-system';

import './IntegrationsSkeletonLoader.css';

/**
 * Skeletion Loader Component
 */
function IntegrationsSkeletonLoader() {
  return (
    <ListRow
      leadingComp={
        <SkeletonLoader
          shape='circle'
          animationStyle='wave'
          height='3rem'
          width='3rem'
          dataTestId='integrations-skeleton-loader-circle'
        />
      }
      centerContent={
        <Box className='Integrations-SkeletonLoader-CenterContent'>
          <Box className='Integrations-SkeletonLoader-CenterContent-Data'>
            <SkeletonLoader
              shape='square'
              animationStyle='wave'
              height='1rem'
              width='100%'
              dataTestId='integrations-skeleton-loader-square'
            />
          </Box>
          <Box className='Integrations-SkeletonLoader-CenterContent-Data'>
            <SkeletonLoader
              shape='square'
              animationStyle='wave'
              height='1rem'
              width='100%'
              dataTestId='integrations-skeleton-loader-square'
            />
          </Box>
          <Box />
        </Box>
      }
      isListItem={false}
      isCheckboxDisabled
    />
  );
}

export default IntegrationsSkeletonLoader;
